var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationSeverityInfoBlue = function SvgNotificationSeverityInfoBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.5 4.667a2.167 2.167 0 1 0 4.333 0 2.167 2.167 0 0 0-4.333 0M2.5 11.333a2.167 2.167 0 1 0 4.333 0 2.167 2.167 0 0 0-4.333 0M9.167 4.667a2.167 2.167 0 1 0 4.333 0 2.167 2.167 0 0 0-4.333 0M9.167 11.333a2.167 2.167 0 1 0 4.333 0 2.167 2.167 0 0 0-4.333 0M6.333 9.667l3.334-3.334"
  })));
};
export { SvgNotificationSeverityInfoBlue as ReactComponent };
export default __webpack_public_path__ + "fb489bfccaa2af97e6211df659309c79.svg";